import { Toast } from "src/components";
import { CONTACT_ADDING_TYPE } from "../constants";

export const CsvFileHooks = (setCsvData, setErrors = () => { }, navigateToReview = () => { }) => {
    const expectedHeaders = ["First Name", "Last Name", "Email", "Mobile Number(Optional)", "Reference(Optional)"];

    // Format header to match expected format
    // e.g., "First Name (Optional)" -> "firstName"
    const formatHeader = (header) =>
        header
            .replace(/\s+/g, " ")
            .split("(")[0]
            .trim()
            .replace(/\s(.)/g, (m, g1) => g1.toUpperCase())
            .replace(/\s/g, "")
            .replace(/^(.)/, (m, g1) => g1.toLowerCase());

    const handleCsvUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target.result;

            const rows = text.split(/\r?\n/).filter((line) => line.trim() !== "");
            const headers = rows[0].split(",").map((h) => h.trim());

            // Validate headers
            const isValid = JSON.stringify(headers) === JSON.stringify(expectedHeaders);

            if (isValid) {
                // Toast.success("✅ CSV headers are valid!");
                if (setErrors) {
                    setErrors((prevErrors) => ({ ...prevErrors, contact: "" }));
                }
                // Extract headers and format them
                const formattedHeaders = rows[0].split(",").map((h) => formatHeader(h));

                // Convert remaining rows into objects
                const objects = rows.slice(1).map((row) => {
                    const values = row.split(",").map((v) => v.trim());
                    return formattedHeaders.reduce((obj, key, index) => {
                        obj[key] = values[index] || "";
                        obj.type = CONTACT_ADDING_TYPE.CSV;
                        return obj;
                    }, {});
                });
                setCsvData(objects);
                navigateToReview();
            } else {
                Toast.error(
                    // `❌ Invalid headers. Found: [${headers.join(
                    //     ", "
                    // )}] Expected: [${expectedHeaders.join(", ")}]`
                    `❌ Invalid headers. Expected: [${expectedHeaders.join(", ")}]`
                );
            }
        };

        reader.onerror = () => Toast.error("Error reading file");
        reader.readAsText(file);
    };

    return {
        handleCsvUpload,
    };
};
